<template>
    <button
        class="h-9 px-3 flex items-center gap-2 text-sm font-medium tracking-wide capitalize rounded-md text-white bg-primary hover:opacity-80 transition-all"
        @click.prevent="openCanvas('sidebar')">
        <i class="lab lab-line-add-circle"></i>
        <span>{{ props.title }}</span>
    </button>
</template>

<script>

import { useCanvas } from "../../../../composables/canvas";

export default {
    name: "SmSidebarModalCreateComponent",
    props: ['props'],
    data() {
        return {
            openCanvas: useCanvas().openCanvas
        }
    }
}
</script>